import React from 'react'
import cross from '../../../assets/images/cross.png';
import IcCancel from '../../../assets/images/ic_cancel.png';

export const About = () =>
    <div className="modal fade in mypopup" id="about" role="dialog" aria-hidden="false">
        <div className="modal-dialog modal-lg" dir="ltr">
            <button type="button" className="close" data-dismiss="modal">
                <img className={'desktop'} src={cross} alt=""/>
                <img className={'mobile'} src={IcCancel} alt=""/>
            </button>
            <div className={'en-popup-text'}>
                <h1 className="f black">How to use</h1>
                <div className={'txt'}>
                    <p>How to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to use</p>
                </div>
                <p>How to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to useHow to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to useHow to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to use</p>
                <p>How to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to useHow to use How to usevvv How to use v How to use How to use How to use How to use How to use How to use How to use How to use</p>
            </div>
            <div className={'he-popup-text'}>
                <h1 className="f black">איך זה עובד</h1>
                <div className={'txt'}>
                    <p>על קצה הלשון, הוא כלי שנועד לסייע לכם לאתר את המילים שאתם מחפשים, בעזרת מילים נרדפות, מילים זהות במשמעות ועוד.</p>
                </div>
                <p><strong>חפשו מילה הדומה</strong>  - בחרו בין סגנון ניקוד מודרני, רבני או שירה, על ידי לחיצה על הכפתור ״שנה סגנון ניקוד״, המופיע לצד הלוגו.<br/><br/>
                    <strong>חפשו מילה הפוכה</strong>- אם הזנתם טקסט שאינו תואם את סגנון הנקדן, כאשר תלחצו על ״נקד״ תופיעה הודעה שתמליץ לכם על סגנון הנקדן המותאם לטקסט שלכם. תוכלו לבחור לעבור לנקדן המותאם, או להתעלם מההודעה. </p>
                <h3 className="f black" style={{fontWeight:'700'}}>תוצאות חיפוש</h3>
                <p> בתוצאות החיפוש נציג מגוון מילים אפשריות המתעדכנות בזמן אמת. <br/><br/>
                    <strong>חפשו מילה הפוכה</strong>  - הזינו טקסט לתיבת הטקסט או הדביקו טקסט ממקור חיצוני. לחצו על הכפתור "ניקוד". </p>
            </div>
        </div>
    </div>;


// WEBPACK FOOTER //
// ./src/components/home/includes/About.js